import React from 'react';
import {Grid, TextField} from "@mui/material";
import Label from "../../Label";
import {Controller} from "react-hook-form";
import ErrorMessage from "../ErrorMessage";

const TextOtherField = ({
                            control,
                            name,
                        }) => {
    return (
        <Controller
            control={control}
            name={name}
            render={({field, fieldState: {error}}) => {
                return (
                    <TextField
                        {...field}
                        ref={field.ref}
                        sx={{my: 0.5}}
                        multiline
                        error={error?.message}
                        placeholder="Nhâp nội dung chi tiết"
                        helperText={<ErrorMessage message={error?.message}/>}
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                        size="small"
                        FormHelperTextProps={{variant: "standard"}}
                    />
                );
            }}
        />
    )
}

export default TextOtherField